export default __webpack_public_path__ + "static/media/pluto.20c57698.svg";